import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=02c4ba5b&"
import script from "./AddUser.js?vue&type=script&lang=js&"
export * from "./AddUser.js?vue&type=script&lang=js&"
import style0 from "./AddUser.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports